import {
  RhDrawer,
  RhIcon,
  RhScrollbar,
  RhTimeline,
  RhTimelineItem,
} from "@rhythm-ui/react";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import React, { useContext } from "react";

import { AuthContext } from "@/context/AuthContext";

import { JobType } from "@/types/job";

import api from "@/services/api";

import CandidateLogsSkeleton from "@/components/skeletons/candidate/CandidateLogsSkeleton";

const utc = require("dayjs/plugin/utc");
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(utc);
dayjs.extend(customParseFormat);

const JobApplicationStatusDrawer = ({
  openJobApplicationStatusDrawer,
  setOpenJobApplicationStatusDrawer,
}: {
  openJobApplicationStatusDrawer: JobType | null;
  setOpenJobApplicationStatusDrawer: React.Dispatch<
    React.SetStateAction<JobType | null>
  >;
}) => {
  const { auth } = useContext(AuthContext);

  const candidateId = auth.candidateId;

  const onDrawerClose = () => {
    setOpenJobApplicationStatusDrawer(null);
  };

  const job = openJobApplicationStatusDrawer;

  const {
    data: candidateJobApplicationActivityLog,
    isLoading: isActivityLogLoading,
  } = useQuery({
    queryKey: ["candidate-job-activities", candidateId, job],
    queryFn: () => {
      return api.company.getCandidateJobApplicationActivity({
        candidate_id: candidateId,
        job_requirement_id: job.id,
        type: "opportunities",
        pagination: false,
      });
    },
    select: (data) => {
      return data.data;
    },
    enabled: !!(candidateId && job && job.id),
  });

  return (
    <RhDrawer
      className=" flex flex-col w-[700px]"
      variant="temporary"
      position="right"
      //   size="medium"
      isOpen={!!openJobApplicationStatusDrawer}
      backdrop
      onClose={onDrawerClose}
      closeOnOutsideClick
    >
      <div
        onClick={onDrawerClose}
        className={
          "absolute rounded-lg bg-white cursor-pointer top-tnano p-tnano flex justify-center items-center " +
          (openJobApplicationStatusDrawer !== null ? "-left-txl" : "")
        }
      >
        <RhIcon icon="mdi:close"></RhIcon>{" "}
      </div>
      <div className="m-tm2 flex flex-col h-full">
        <div className="flex gap-tm2 items-center pb-tsm">
          {job?.company.logo && (
            <img
              className="h-[88px] w-[88px] rounded-md"
              src={job?.company.logo}
              alt={job?.company.name}
            />
          )}
          <div>
            <h2 className="mb-tnano">{job?.title}</h2>
            <p className="theme-text-dark">{job?.company.name}</p>
          </div>
        </div>

        {isActivityLogLoading && <CandidateLogsSkeleton />}

        {candidateJobApplicationActivityLog &&
        candidateJobApplicationActivityLog.length == 0 &&
        !isActivityLogLoading ? (
          <div className="flex items-center justify-center w-full">
            <div className="text-center text-light"> No Logs found</div>
          </div>
        ) : (
          <>
            {!isActivityLogLoading && (
              <div className="flex-1 overflow-hidden">
                <RhScrollbar className="h-full p-tsm">
                  <RhTimeline
                    align={"right"}
                    timelineLineClass={""}
                    timelineCircleClass={""}
                  >
                    {candidateJobApplicationActivityLog &&
                      candidateJobApplicationActivityLog.map((item) => {
                        return (
                          <RhTimelineItem key={item.id}>
                            <p>{item.description}</p>
                          </RhTimelineItem>
                        );
                      })}
                  </RhTimeline>
                </RhScrollbar>
              </div>
            )}
          </>
        )}
      </div>
    </RhDrawer>
  );
};

export default JobApplicationStatusDrawer;
